module.exports = __webpack_public_path__ + "img/kuwait.44e23d1e.png";